import { render, staticRenderFns } from "./CombinedQuestions.vue?vue&type=template&id=e6a8ed2e&scoped=true&"
import script from "./CombinedQuestions.vue?vue&type=script&lang=js&"
export * from "./CombinedQuestions.vue?vue&type=script&lang=js&"
import style0 from "./CombinedQuestions.vue?vue&type=style&index=0&id=e6a8ed2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a8ed2e",
  null
  
)

export default component.exports